import ProtectedRoute from '../users/components/protected-route/protected-route'
import { lazy } from 'react'
const Dashboard = lazy(() => import('./pages/dashboard/dashboard'))

const routes = [
  {
    path: '/*',
    element: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    )
  }
]

export { ALL_TIMESHEET_RECORDS_ROUTE } from './route-paths'
export default routes
